/* @flow */

import { callLiferayEndpoint } from './index';
import type { Endpoint, OnDemand } from 'types';
import utils from './utils';

const submit = async (request: OnDemand): Promise<boolean> => {
  const endpoint: Endpoint = '/protones-portlet.mailrequest/send-quotation-request';
  const mailRequest = utils.toMailRequest(request);
  if (!mailRequest) {
    return false;
  }
  await callLiferayEndpoint(endpoint, mailRequest);
  return true;
};

export default {
  submit,
};
